var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0833 4.95834H9.91665C5.66665 4.95834 2.83331 7.08334 2.83331 12.0417V21.9583C2.83331 26.9167 5.66665 29.0417 9.91665 29.0417H24.0833C28.3333 29.0417 31.1666 26.9167 31.1666 21.9583V12.0417C31.1666 7.08334 28.3333 4.95834 24.0833 4.95834ZM24.7491 13.5858L20.315 17.1275C19.38 17.8783 18.19 18.2467 17 18.2467C15.81 18.2467 14.6058 17.8783 13.685 17.1275L9.25081 13.5858C8.79748 13.2175 8.72665 12.5375 9.08081 12.0842C9.44915 11.6308 10.115 11.5458 10.5683 11.9142L15.0025 15.4558C16.0791 16.32 17.9066 16.32 18.9833 15.4558L23.4175 11.9142C23.8708 11.5458 24.5508 11.6167 24.905 12.0842C25.2733 12.5375 25.2025 13.2175 24.7491 13.5858Z",
    fill: "#3C3D3F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSms);
export default __webpack_public_path__ + "static/media/sms.69535235e5a356280cc2f10f9f87e9b8.svg";
export { ForwardRef as ReactComponent };